import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Information',
      href: '/en/Software/macOS/InstarVision/About/'
    },
    {
      text: 'Tools',
      href: '/en/Software/macOS/InstarVision/Advanced/',
    },
    {
      text: 'Cameras',
      href: '/en/Software/macOS/InstarVision/Camera_List/'
    },
    {
      text: 'Record',
      href: '/en/Software/macOS/InstarVision/Image_Adjust/'
    },
    {
      text: 'Switch',
      href: '/en/Software/macOS/InstarVision/Layout/'
    },
    {
      text: 'PTZ',
      href: '/en/Software/macOS/InstarVision/PTZ/'
    },
    {
      text: 'System',
      href: '/en/Software/macOS/InstarVision/System/'
    },
    {
      text: 'Users',
      href: '/en/Software/macOS/InstarVision/Users/'
    },
    {
      text: '◄ InstarVision',
      href: '/en/Software/macOS/InstarVision/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={11}
        aria-label="Software Platform for your INSTAR IP Camera"
      />
      <EuiSpacer />
    </Fragment>
  );
}
